module.exports={author:"Sarah Matthes",date:"11/02/2019",publishDate:"11/02/2019",highlighted:!1,tags:"",title:"Averting My Eyes"};